import { render, staticRenderFns } from "./centerPenalty.vue?vue&type=template&id=8b881e14&scoped=true"
import script from "./centerPenalty.vue?vue&type=script&lang=js"
export * from "./centerPenalty.vue?vue&type=script&lang=js"
import style0 from "./centerPenalty.vue?vue&type=style&index=0&id=8b881e14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b881e14",
  null
  
)

export default component.exports